<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            :parentData="parentData"
            modalWidth="90%"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      :label="$t('Entidad califica')"
                      style="width: 100%"
                      :formItemConfig="fiOptions"
                      :decorator="['pcl_entity', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                      :params="entidad">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Fecha estructuración')">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD 00:00:00"
                           v-decorator="['pcl_date_junta', { rules: [{ required: true, message: 'Valor requerido'}] }]"
            ></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Fecha dictamen')">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD 00:00:00"
                           v-decorator="['pcl_date_acta', { rules: [{ required: true, message: 'Valor requerido'}] }]"
            ></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      :label="$t('Estado')"
                      style="width: 100%"
                      :formItemConfig="fiOptions"
                      :decorator="['pcl_status', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                      :params="estado">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <g-lookup :label="$t('Diagnóstico')"
                    :formItemConfig="fiOptions"
                    endpoint="diag"
                    ref="diagnostico"
                    :decorator="['id_diag', { rules: [{ required: true}] }]">
          </g-lookup>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Obs diagnóstico')">
            <a-textarea style="width: 100%"
                        v-decorator="['diag_obs', { rules: [{ required: false, message: 'Valor requerido' }] }]"
            />
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Porcentaje')" v-bind="fiOptions">
            <a-input-number
              v-decorator="['pcl_percent', { rules: [{ required: true, message: 'Valor requerido' }] }]"
              style="width: 100%">
            </a-input-number>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Observaciones')">
            <a-textarea style="width: 100%"
                        v-decorator="['pcl_comments', { rules: [{ required: false, message: 'Valor requerido' }] }]"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>

<script>
  export default {
    props: ['id_case'],
    data () {
      return {
        legal_entities: {
          legal_entities_absen: true
        },
        entidad: {
          h_lookup_type: 'CASOS_ENTIDAD_PCL'
        },
        estado: {h_lookup_type: 'ESTADO_ACT_INA'},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 12},
        master: {
          endpoint: 'pcl_cases',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Entidad', dataIndex: 'entidad_desc', sorter: true},
              {title: 'Fecha dictamen', dataIndex: 'pcl_date_acta', sorter: true},
              {title: 'Fecha estructuración', dataIndex: 'pcl_date_junta', sorter: true},
              {title: 'Estado', dataIndex: 'estado_desc', sorter: true},
              {title: 'Id Diagnostico', dataIndex: 'id_diag', sorter: true},
              {title: 'Diagnóstico', dataIndex: 'diag_desc', sorter: true},
              {title: 'Obs. diagnóstico', dataIndex: 'diag_obs', sorter: true},
              {title: 'Porcentaje', dataIndex: 'pcl_percent', sorter: true},
              {title: 'Observaciones', dataIndex: 'pcl_comments', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'pcl_entity'},
            {name: 'pcl_comments'},
            {name: 'pcl_date_acta'},
            {name: 'pcl_date_junta'},
            {name: 'pcl_status'},
            {name: 'pcl_percent'},
            {name: 'id_diag'},
            {name: 'diag_obs'}

          ]
        }
      }
    },
    computed: {
      parentData () {
        return {id_case: this.id_case}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/PCL.vue